module.exports = __webpack_public_path__ + "img/default-tablet-arabic-no-content.6d02aeef.png";